import { render, staticRenderFns } from "./faq_content.vue?vue&type=template&id=41a796b8&scoped=true"
import script from "./faq_content.vue?vue&type=script&setup=true&lang=js"
export * from "./faq_content.vue?vue&type=script&setup=true&lang=js"
import style0 from "./faq_content.vue?vue&type=style&index=0&id=41a796b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a796b8",
  null
  
)

export default component.exports